import React, { useState, useEffect, useRef } from "react";
import "./css/styles.css";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { getDownloadURL, uploadBytesResumable, ref } from "firebase/storage";

import { Card, Button, TextField, FormControl, Box } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import ProgressBar from "./ProgressBar";

import {
  collection,
  getDocs,
  setDoc,
  updateDoc,
  doc,
  query,
  where,
  orderBy,
  getDoc,
} from "firebase/firestore";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import { useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FileUploader from "react-firebase-file-uploader";
import { db, storage, app } from "../firebase";
import { muiBbtn } from "./style";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
export default function ViewCountryNews() {
  const { DocId } = useParams();
  const [newsData, setNewsData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "countryNews", DocId);

        const newsCollectionRef = collection(docRef, "news");
        const newsQuery = query(newsCollectionRef);
        const newsSnapshot = await getDocs(newsQuery);

        const newsArray = [];
        newsSnapshot.forEach((doc) => {
          newsArray.push(doc.data());
        });

        setNewsData(newsArray);
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [DocId]);

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        backgroundColor: "#212C62",
      }}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Card style={{ padding: 60, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-12 mb-4 py-4">
            <h1 className="" style={{ textAlign: "left", color: "#212C62" }}>
              <b>{}</b>
            </h1>

            {newsData.length > 0 ? (
              newsData.map((newsItem, index) => (
                <div
                  className="col-12 d-flex flex-wrap border my-3 p-3 rounded"
                  key={index}
                >
                  {newsItem.imageUrl ? (
                    <div className="col-lg-2 col-md-3 col-3">
                      <img src={newsItem.imageUrl} className="w-100" alt="" />
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col ps-3">
                    <a target="_blank" href={newsItem.link}>
                      {" "}
                      <h2>{newsItem.title}</h2>
                    </a>
                    <p>{newsItem.excerpt}</p>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-muted text-center">No News Found</p>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
}
